import React from 'react';
import './TopServicesWidget.css';

interface Service {
  billing_entity: string;
  item_type: string;
  billing_currency: string;
  meter_category: string;
  totalcost: number;
}

interface TopServicesWidgetProps {
  services: Service[];
  loading: boolean;
  companyName: string;
}

const TopServicesWidget: React.FC<TopServicesWidgetProps> = ({
  services,
  loading,
  companyName,
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const getCurrentMonth = () => {
    const date = new Date();
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
  };

  const topFiveServices = services?.slice(0, 5) || [];

  if (loading) {
    return (
      <div className="topServicesWidget">
        <div className="topServicesHeader">
          <h3 className="topServicesTitle">Top 5 AWS Services</h3>
          <p className="topServicesSubtitle">
            Current Month - {getCurrentMonth()}
          </p>
        </div>
        <div className="topServicesLoading">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="serviceItemSkeleton">
              <div className="skeletonBar"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!services || services.length === 0) {
    return (
      <div className="topServicesWidget">
        <div className="topServicesHeader">
          <h3 className="topServicesTitle">Top 5 AWS Services</h3>
          <p className="topServicesSubtitle">
            Current Month - {getCurrentMonth()}
          </p>
        </div>
        <div className="topServicesEmpty">
          <p className="emptyStateText">No service data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="topServicesWidget">
      <div className="topServicesHeader">
        <h3 className="topServicesTitle">Top 5 AWS Services</h3>
        <p className="topServicesSubtitle">
          Current Month - {getCurrentMonth()}
        </p>
      </div>

      <div className="servicesListContainer">
        {topFiveServices.map((service, index) => (
          <div key={service.meter_category + index} className="serviceItem">
            <div className="serviceContent">
              {/* <div className="serviceRank">{index + 1}</div> */}
              <div className="serviceDetails">
                <h4 className="serviceName">{service.meter_category}</h4>
                <span className="serviceEntity">{service.billing_entity}</span>
              </div>
              <div className="serviceCost">
                {formatCurrency(service.totalcost)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopServicesWidget;
